import { Button, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { useConnect } from "@stacks/connect-react";
import { useEffect, useState } from "react";
import {
    AnchorMode, PostConditionMode, stringUtf8CV, stringAsciiCV, trueCV, falseCV, uintCV,
    someCV, makeStandardSTXPostCondition, FungibleConditionCode, noneCV, standardPrincipalCV,
} from "@stacks/transactions";
import BaseModal from "../baseModal";
import { network, getUserData, authenticatedUserAddress } from "../../services/auth";
import { deruptInterfaceAddress, stacksExplorerParam, clientNetwork } from "../../lib/constants";
import { getinterfaceCost } from "../../services/interface_getters";
import OutlinedInput from '@mui/material/OutlinedInput';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const appOrigin = window.location.origin;
const MintOriginModal = ({ show, close }) => {
    const { doContractCall } = useConnect();
    // Interface mint states values
    const [altOrigin, setAltOrigin] = useState(appOrigin);
    const [metadataUri, setMetadataUri] = useState(`${appOrigin}/metadata.json`);
    const [payDev, setPayDev] = useState(true);
    const [payGaia, setPayGaia] = useState(false);
    const [devStxAmount, setDevStxAmount] = useState(0.1);
    const [gaiaStxAmount, setGaiaStxAmount] = useState(0);
    const [devFtAmount, setDevFtAmount] = useState(3);
    const [gaiaFtAmount, setGaiaFtAmount] = useState(0);
    //const [devPrincipal] = useState(getUserData().profile.stxAddress.testnet);
    const [devPrincipal] = useState(authenticatedUserAddress({ network: clientNetwork }));
    console.log("p2 automagic networking: " + devPrincipal)
    const [gaiaPrincipal, setGaiaPrincipal] = useState('');

    const [defaultOrigins, setDefaultOrigins] = useState(true);
    function changeDefaultOrigin() {
        setDefaultOrigins(!defaultOrigins);
    }

    const [mintBtn, setMintBtn] = useState(true);

    async function mint() {
        const { "mint-cost": mintCost } = await getinterfaceCost();
        const contractAddress = deruptInterfaceAddress.split('.')[0];
        const contractName = deruptInterfaceAddress.split('.')[1].split('::')[0];
        const postConditionAddress = devPrincipal;
        const postConditionCode = FungibleConditionCode.LessEqual;
        const postConditionAmount = mintCost?.value;
        const standardSTXPostCondition = makeStandardSTXPostCondition(
            postConditionAddress,
            postConditionCode,
            postConditionAmount
        );
        const gaiaPrincipalValue = gaiaPrincipal ? someCV(standardPrincipalCV(gaiaPrincipal)) : noneCV();
        doContractCall({
            network,
            anchorMode: AnchorMode.Any,
            contractAddress,
            contractName,
            functionName: "mint",
            functionArgs: [
                stringUtf8CV(altOrigin),
                stringAsciiCV(metadataUri),
                payDev ? trueCV(payDev) : falseCV(payDev),
                payGaia ? trueCV(payGaia) : falseCV(payGaia),
                uintCV(devStxAmount * 1000000),
                uintCV(gaiaStxAmount * 1000000),
                uintCV(devFtAmount),
                uintCV(gaiaFtAmount),
                standardPrincipalCV(devPrincipal),
                gaiaPrincipalValue,
            ],
            postConditionMode: PostConditionMode.Deny,
            validateWithAbi: true,
            postConditions: [standardSTXPostCondition],
            stxAddress: postConditionAddress,
            onFinish: (data) => {
                console.log("onFinish:", data);
                window
                    .open(
                        `https://explorer.hiro.so/txid/${data.txId}${stacksExplorerParam}`, "_blank"
                    )
                    .focus();
            },
            onCancel: () => {
                console.log("onCancel:", "Transaction was canceled");
            },
        });
    }

    function handleMintValueChanges(event) {
        let amount;
        const { name, value } = event.target;
        switch (name) {
            case 'alt-origin':
                setAltOrigin(value);
                break;
            case 'metadata-uri':
                setMetadataUri(value);
                break;
            case 'pay-dev':
                setPayDev(value);
                break;
            case 'pay-gaia':
                setPayGaia(value);
                break;
            case 'dev-stx-amount':
                amount = parseFloat(value);
                if (!isNaN(amount) && amount <= 100) {
                    amount = Math.max(amount, 0);
                    if (String(amount).length > 1 && !String(amount).includes('.')) amount = String(amount).replace(/^0+/, '');
                    setDevStxAmount(amount);
                } else {
                    setDevStxAmount(devStxAmount);
                }
                break;
            case 'gaia-stx-amount':
                amount = parseFloat(value);
                if (!isNaN(amount) && amount <= 100) {
                    amount = Math.max(amount, 0);
                    if (String(amount).length > 1 && !String(amount).includes('.')) amount = String(amount).replace(/^0+/, '');
                    setGaiaStxAmount(amount);
                } else {
                    setGaiaStxAmount(gaiaStxAmount);
                }
                break;
            case 'dev-ft-amount':
                amount = parseFloat(value);
                if (!isNaN(amount) && amount <= 100) {
                    amount = Math.max(amount, 0);
                    if (String(amount).length > 1 && !String(amount).includes('.')) amount = String(amount).replace(/^0+/, '');
                    setDevFtAmount(amount);
                } else {
                    setDevFtAmount(devFtAmount);
                }
                break;
            case 'gaia-ft-amount':
                amount = parseFloat(value);
                if (!isNaN(amount) && amount <= 100) {
                    amount = Math.max(amount, 0);
                    if (String(amount).length > 1 && !String(amount).includes('.')) amount = String(amount).replace(/^0+/, '');
                    setGaiaFtAmount(amount);
                } else {
                    setGaiaFtAmount(gaiaFtAmount);
                }
                break;
            case 'gaia-principal':
                setGaiaPrincipal(value);
                break;
        }
    }

    useEffect(() => {
        if (payDev) {
            if (devStxAmount > 0 && devFtAmount > 0) {
                setMintBtn(false);
            } else {
                setMintBtn(true);
            }
        } else if (payGaia) {
            if ((gaiaStxAmount > 0 && gaiaFtAmount > 0) && gaiaPrincipal) {
                setMintBtn(false);
            } else {
                setMintBtn(true);
            }
        } else {
            setMintBtn(false);
        }
    }, [payGaia, gaiaPrincipal, gaiaStxAmount, gaiaFtAmount, payDev, devStxAmount, devFtAmount])

    return (
        <BaseModal title={"Mint Origin Modal"} show={show} handleClose={close} >
            <div id="origin-modals">
                {/* <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                    <FormControlLabel onChange={changeDefaultOrigin} checked={defaultOrigins} sx={{ color: 'black' }} value="default" control={<Radio />} label="Default" />
                    <FormControlLabel onChange={changeDefaultOrigin} checked={!defaultOrigins} sx={{ color: 'black' }} value="custom" control={<Radio />} label="Custom" />
                </RadioGroup> */}

                <TextField onChange={handleMintValueChanges} name="alt-origin" value={altOrigin} fullWidth required id="outlined-basic" label="alt-origin" InputProps={{ readOnly: defaultOrigins }} />
                <TextField onChange={handleMintValueChanges} name="metadata-uri" value={metadataUri} fullWidth required id="outlined-basic" label="metadata-uri" InputProps={{ readOnly: defaultOrigins }} />

                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', width: '100%', gap: '2%' }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-multiple-name-label">pay-dev</InputLabel>
                            <Select name="pay-dev" labelId="demo-multiple-name-label" id="demo-multiple-name" value={payDev} onChange={handleMintValueChanges} input={<OutlinedInput label="pay-dev" />} MenuProps={MenuProps}>
                                <MenuItem value={true}>True</MenuItem>
                                <MenuItem value={false}>False</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel id="demo-multiple-name-label">pay-gaia</InputLabel>
                            <Select name="pay-gaia" labelId="demo-multiple-name-label" id="demo-multiple-name" value={payGaia} onChange={handleMintValueChanges} input={<OutlinedInput label="pay-gaia" />} MenuProps={MenuProps}>
                                <MenuItem value={true}>True</MenuItem>
                                <MenuItem value={false}>False</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div style={{ marginTop: '2%', display: 'flex', width: '100%', gap: '2%' }}>
                        <TextField onChange={handleMintValueChanges} name="dev-stx-amount" value={devStxAmount} fullWidth required id="outlined-basic" label="dev-stx-amount" type="number" inputProps={{ step: '0.1' }} helperText={`Your Imposed STX Service Fee of ${devStxAmount} (STX)`} InputProps={{ readOnly: !payDev, min: 0, max: 100, step: 0.01 }} />
                        <TextField onChange={handleMintValueChanges} name="gaia-stx-amount" value={gaiaStxAmount} fullWidth required id="outlined-basic" label="gaia-stx-amount" type="number" inputProps={{ step: '0.1' }} helperText={`Your Imposed STX Storage Fee of ${gaiaStxAmount} (STX)`} InputProps={{ readOnly: !payGaia, min: 0, max: 100, step: 0.01 }} />
                    </div>

                    <div style={{ marginTop: '2%', display: 'flex', width: '100%', gap: '2%' }}>
                        <TextField onChange={handleMintValueChanges} name="dev-ft-amount" value={devFtAmount} fullWidth required id="outlined-basic" label="dev-ft-amount" type="number" inputProps={{ step: '0.1' }} helperText={`Your Imposed CryptoCash Service Fee of ${devFtAmount} (FT)`} InputProps={{ readOnly: !payDev, min: 0, max: 100, step: 0.01 }} />
                        <TextField onChange={handleMintValueChanges} name="gaia-ft-amount" value={gaiaFtAmount} fullWidth required id="outlined-basic" label="gaia-ft-amount" type="number" inputProps={{ step: '0.1' }} helperText={`Your Imposed CryptoCash Storage Fee of ${gaiaFtAmount} (FT)`} InputProps={{ readOnly: !payGaia, min: 0, max: 100, step: 0.01 }} />
                    </div>

                    <div style={{ marginTop: '2%', display: 'flex', width: '100%', gap: '2%' }}>
                        <TextField onChange={handleMintValueChanges} name="dev-principal" value={devPrincipal} fullWidth id="outlined-basic" label="dev-prinipal" InputProps={{ readOnly: true }} />
                        <TextField onChange={handleMintValueChanges} name="gaia-principal" value={gaiaPrincipal} fullWidth id="outlined-basic" label="gaia-prinipal" InputProps={{ readOnly: !payGaia }} />
                    </div>
                </div>

                <Button onClick={mint} disabled={mintBtn} variant="contained">Mint</Button>
            </div>
        </BaseModal >
    );
}

export default MintOriginModal;